import styled from "@emotion/styled";

import { DesignToken, Text } from "@livechat/design-system-react-components";

export const TeamContainer = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
`;

export const TeamData = styled.div`
  flex: 1;
  margin-left: 10px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  line-height: 20px;
  min-width: 0;
`;

interface IValue {
  faded?: boolean;
}

export const Value = styled(Text)<IValue>`
  ${({ faded }): string => (faded ? `color: var(${DesignToken.ContentBasicDisabled});` : "")};
  white-space: pre-wrap;
  word-break: break-all;
  word-break: break-word;
`;

export const AssigneeContainer = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
`;

export const FollowersContainer = styled.div`
  display: flex;
  margin: 10px 0;
  align-items: center;
`;

export const StyledAvatar = styled.div`
  display: flex;
  align-items: center;

  img {
    display: block;
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }
`;

export const UserData = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-direction: column;
  margin-left: 10px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
  line-height: 20px;
`;

export const NoAgentInfo = styled(Text)`
  color: var(${DesignToken.ContentBasicDisabled});
`;
